// DOM adapter for Metabase's SDK, not a supported SDK extension point.
// Keep selectors isolated and recheck them when upgrading Metabase.
export const DASHBOARD_HEADER_SELECTOR =
  '[data-grid-header-cell-content], [data-testid="header-cell"], th, [role="columnheader"]';

const normalize = (value) => String(value ?? '').trim().replace(/\s+/g, ' ').toLowerCase();

export function buildDashboardColumnDescriptions(dashboard) {
  const index = new Map();
  for (const dashcard of dashboard?.dashcards || []) {
    // Combined/visualizer cards need their own lineage mapping. Fail closed.
    if (!dashcard.card || dashcard.series?.length || dashcard.visualization_settings?.visualization) continue;
    const columns = dashcard.card.result_metadata;
    if (!Array.isArray(columns)) continue;
    const aliases = new Map();
    for (const column of columns) {
      const description = typeof column.description === 'string' ? column.description.trim() : '';
      const key = JSON.stringify(['name', column.name]);
      const settings = {
        ...dashcard.card.visualization_settings?.column_settings?.[key],
        ...dashcard.visualization_settings?.column_settings?.[key],
      };
      // Header titles override metadata names. Do not additionally index the
      // old name: a different displayed column may now use that label.
      const title = typeof settings.column_title === 'string' && settings.column_title.trim()
        ? settings.column_title : column.display_name || column.name;
      for (const name of [normalize(title)]) {
        if (!name) continue;
        // Duplicate labels are ambiguous even if only one has a description.
        aliases.set(name, aliases.has(name) ? null : description || null);
      }
    }
    // Metabase has used both the dashboard-card id and the underlying card id
    // for data-dashcard-key across dashboard/SDK renderers. Index both exact
    // identifiers; do not fall back to a global column-name match.
    for (const id of [dashcard.id, dashcard.card.id]) {
      if (id == null) continue;
      const key = String(id);
      if (!index.has(key)) index.set(key, aliases);
      else if (index.get(key) !== aliases) index.set(key, null);
    }
  }
  return index;
}

export function resolveDashboardColumnDescription(target, shell, index) {
  if (!(target instanceof Element)) return null;
  const header = target.closest(DASHBOARD_HEADER_SELECTOR);
  if (!header || !shell.contains(header)) return null;
  const card = header.closest('[data-dashcard-key]');
  if (!card || !shell.contains(card)) return null;
  const content = header.querySelector('[data-grid-header-cell-content]') || header;
  const description = index.get(card.getAttribute('data-dashcard-key'))?.get(normalize(content.textContent));
  return description ? { header, description } : null;
}
